/**
 * Predictive search for snippets/predictive-search.liquid.
 *
 * Debounced queries against Shopify's /search/suggest.json endpoint,
 * rendering product and collection suggestions with keyboard support
 * (arrows, Enter, Escape). Progressive enhancement: without JS the
 * form submits to /search as usual.
 */
(function() {
  'use strict';

  var ENDPOINT = '/search/suggest.json';
  var DEBOUNCE_MS = 250;
  var MIN_CHARS = 2;

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = String(str == null ? '' : str);
    return div.innerHTML;
  }

  function init(root) {
    var input = root.querySelector('[data-ps-input]');
    var results = root.querySelector('[data-ps-results]');
    if (!input || !results) return;

    var timer = null;
    var controller = null;
    var cache = {};
    var activeIndex = -1;

    function close() {
      results.hidden = true;
      results.innerHTML = '';
      input.setAttribute('aria-expanded', 'false');
      activeIndex = -1;
    }

    function items() {
      return results.querySelectorAll('[data-ps-option]');
    }

    function setActive(index) {
      var opts = items();
      if (!opts.length) return;
      activeIndex = (index + opts.length) % opts.length;
      opts.forEach(function(el, i) {
        el.setAttribute('aria-selected', i === activeIndex ? 'true' : 'false');
      });
      opts[activeIndex].scrollIntoView({ block: 'nearest' });
    }

    function render(data, query) {
      var res = (data && data.resources && data.resources.results) || {};
      var products = res.products || [];
      var collections = res.collections || [];
      var html = '';

      if (products.length) {
        html += '<p class="predictive-search__group-title">Products</p>';
        products.forEach(function(p) {
          var img = p.featured_image && p.featured_image.url ? p.featured_image.url : p.image;
          html += '<a class="predictive-search__item" role="option" aria-selected="false" data-ps-option href="' + escapeHtml(p.url) + '">' +
            (img ? '<img class="predictive-search__thumb" src="' + escapeHtml(img) + '" alt="" width="42" height="42" loading="lazy">' : '') +
            '<span><span class="predictive-search__item-title">' + escapeHtml(p.title) + '</span>' +
            (p.price ? '<span class="predictive-search__item-price">$' + escapeHtml(p.price) + '</span>' : '') +
            '</span></a>';
        });
      }
      if (collections.length) {
        html += '<p class="predictive-search__group-title">Collections</p>';
        collections.forEach(function(c) {
          html += '<a class="predictive-search__item" role="option" aria-selected="false" data-ps-option href="' + escapeHtml(c.url) + '">' +
            '<span class="predictive-search__item-title">' + escapeHtml(c.title) + '</span></a>';
        });
      }

      if (!html) {
        html = '<p class="predictive-search__empty">No matches — press Enter to search everything</p>';
      }
      html += '<a class="predictive-search__all" role="option" aria-selected="false" data-ps-option href="/search?type=product&q=' +
        encodeURIComponent(query) + '">See all results for “' + escapeHtml(query) + '”</a>';

      results.innerHTML = html;
      results.hidden = false;
      input.setAttribute('aria-expanded', 'true');
      activeIndex = -1;
    }

    function search(query) {
      if (cache[query]) {
        render(cache[query], query);
        return;
      }
      if (controller) controller.abort();
      controller = typeof AbortController !== 'undefined' ? new AbortController() : null;

      var url = ENDPOINT +
        '?q=' + encodeURIComponent(query) +
        '&resources[type]=product,collection' +
        '&resources[limit]=6' +
        '&resources[options][unavailable_products]=last' +
        '&resources[options][fields]=title,product_type,variants.title,vendor,tag';

      fetch(url, {
        headers: { Accept: 'application/json' },
        signal: controller ? controller.signal : undefined
      })
        .then(function(r) { return r.json(); })
        .then(function(data) {
          cache[query] = data;
          if (input.value.trim() === query) render(data, query);
        })
        .catch(function(err) {
          if (err && err.name === 'AbortError') return;
          close(); // fail silent: plain form submit still works
        });
    }

    input.addEventListener('input', function() {
      var q = input.value.trim();
      clearTimeout(timer);
      if (q.length < MIN_CHARS) {
        close();
        return;
      }
      timer = setTimeout(function() { search(q); }, DEBOUNCE_MS);
    });

    input.addEventListener('keydown', function(e) {
      if (results.hidden) return;
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        setActive(activeIndex + 1);
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        setActive(activeIndex - 1);
      } else if (e.key === 'Enter' && activeIndex >= 0) {
        e.preventDefault();
        var opt = items()[activeIndex];
        if (opt) window.location.href = opt.href;
      } else if (e.key === 'Escape') {
        close();
      }
    });

    input.addEventListener('focus', function() {
      var q = input.value.trim();
      if (q.length >= MIN_CHARS && cache[q]) render(cache[q], q);
    });

    document.addEventListener('click', function(e) {
      if (!root.contains(e.target)) close();
    });
  }

  function boot() {
    document.querySelectorAll('[data-predictive-search]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
